import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface DudaConfiguration {
  dudaSiteName: string;
}

export interface GetDudaConfigurationResponse {
  id: number;
  businessId: number;
  dudaSiteName: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
}
export const getDudaConfiguration = (
  businessId: number,
): AxiosPromise<GetDudaConfigurationResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/duda`,
  });
};

export interface AddDudaConfigurationPayload {
  businessId: number;
  data: DudaConfiguration;
}
export const addDudaConfiguration = ({ businessId, data }: AddDudaConfigurationPayload) => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/duda`,
    data,
  });
};

export interface EditDudaConfigurationPayload {
  businessId: number;
  data: Partial<DudaConfiguration>;
}
export const editDudaConfiguration = ({ businessId, data }: EditDudaConfigurationPayload) => {
  return httpClient({
    method: 'PATCH',
    url: `/super-admin/businesses/${businessId}/duda`,
    data,
  });
};
